/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCategoryControllerRemoveMutationResponse, IncidentCategoryControllerRemovePathParams } from "../../models/incidentAgentController/IncidentCategoryControllerRemove";

function getIncidentCategoryControllerRemoveUrl(id: IncidentCategoryControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/incident-agent/categories/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/categories/:id}
 */
export async function incidentCategoryControllerRemove(id: IncidentCategoryControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentCategoryControllerRemoveMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getIncidentCategoryControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}